import { useTheme } from '@mui/material';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  Button,
  CustomSelect,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Icon,
} from 'web-library';
import { IconName } from 'web-library/stories/atom/Icon/Icon';
import { useGetNonNationalExamGroups } from '../../../../api-refactored/candidate/useGetNonNationalExamGroups';
import { KeyValueResponse } from '../../../../api-refactored/typings';
import { MenuItems } from '../../../../components/select/model';

interface INonNationalExamGroupsExportResult {
  classes: any;
  isOpenDialogExport: boolean;
  onCancelDialogExport: () => void;
  selectExamGroup: KeyValueResponse | undefined;
  setDialogOpen: (_isOpen: boolean) => void;
  onBulkDownload: (_selectExamGroup: KeyValueResponse) => void;
  onCloseDialogExport: () => void;
  onSelectExamGroup: (selectOption: KeyValueResponse) => void;
}

const NonNationalExamGroupsExportResultModal = ({
  classes,
  isOpenDialogExport,
  onCancelDialogExport,
  selectExamGroup,
  setDialogOpen,
  onBulkDownload,
  onCloseDialogExport,
  onSelectExamGroup,
}: INonNationalExamGroupsExportResult) => {
  const { t } = useTranslation();
  const theme = useTheme();

  const { data: nonNationalExamGroups } = useGetNonNationalExamGroups();
  const dropDownData = useMemo<MenuItems[]>(() => {
    if (!nonNationalExamGroups) {
      return [];
    }
    return nonNationalExamGroups.map((option) => ({
      children: option.description,
      value: option.code,
      key: `k-${option.code}`,
    }));
  }, [nonNationalExamGroups]);

  const handleSelectOptionChange = (event: any) => {
    if (nonNationalExamGroups && nonNationalExamGroups.length > 0) {
      const selectedOption = nonNationalExamGroups.find((exam) => exam.code === event.target.value);
      if (selectedOption) {
        onSelectExamGroup(selectedOption);
      }
    }
  };

  return (
    (<Dialog
      id="orgAdmin-export-dialog"
      className={classes.dialogContainer}
      fullWidth
      open={isOpenDialogExport}
      maxWidth="sm"
    >
      <DialogTitle>{t('admin->>ResultRelease.ExportResults')}</DialogTitle>
      <DialogContent className={classes.dialogContent}>
        {t('admin->>ResultRelease.SelectExam')}
        <Box className={classes.examGroup}>
          <CustomSelect
            id="inputSelect-examType"
            label="Exam Group"
            displayEmpty
            onChange={handleSelectOptionChange}
            menuItems={dropDownData}
            variant="filled"
            placeholder="Select exam group"
            fullWidth
          />
        </Box>
      </DialogContent>
      <DialogActions id="orgAdmin-dialog-action">
        <Grid container justify="flex-end" wrap="nowrap" direction="row">
          <Button onClick={onCancelDialogExport} id="button-cancel" variant="text">
            Cancel
          </Button>
          <Button
            id="button-export-results"
            className={classes.customDownloadButton}
            variant="contained"
            onClick={() => {
              if (selectExamGroup) {
                onBulkDownload(selectExamGroup);
                onCloseDialogExport();
                setDialogOpen(true);
              }
            }}
            disabled={selectExamGroup === undefined}
            color="secondary"
            startIcon={
              <Icon name={IconName.export} size="S" color={theme.color.icon.iconInverse} />
            }
          >
            Export
          </Button>
        </Grid>
      </DialogActions>
    </Dialog>)
  );
};

export default NonNationalExamGroupsExportResultModal;
